export default __webpack_public_path__ + "static/P1020532_developed-242d4d55b44f0e8539dd3ab1a886f7c9.jpg";